import React, { useState, useEffect } from "react";

type CouponAreaProps = {
  appliedCoupon: {
    code: string;
    amount: number;
  };
  onApplyCoupon: (code: string) => void;
  onRemoveCoupon: () => void;
  error?: string;
};

const CouponArea: React.FC<CouponAreaProps> = ({
  appliedCoupon,
  onApplyCoupon,
  onRemoveCoupon,
  error
}) => {
  const [isOpenCouponArea, setIsOpenCouponArea] = useState(false);
  const [couponCode, setCouponCode] = useState<string>("");
  const [localError, setLocalError] = useState<string>("");

  useEffect(() => {
    setLocalError(error || "");
  }, [error]);

  const toggleCouponArea = () => {
    setIsOpenCouponArea(!isOpenCouponArea);
  };

  const handleApplyCoupon = () => {
    if (!couponCode) {
      setLocalError("クーポンコードを入力してください");
      return;
    }
    setLocalError("");
    onApplyCoupon(couponCode);
    setCouponCode("");
  };

  const handleRemoveCoupon = () => {
    onRemoveCoupon();
    setCouponCode("");
    setLocalError("");
  };

  return (
    <div className="p-4 border border-gray-400 rounded-md bg-gray-50">
      <button
        onClick={(e) => {
          e.preventDefault();
          toggleCouponArea();
        }}
        className="w-full py-2 bg-gray-200 text-gray-700 font-bold rounded-md hover:bg-gray-300 transition"
      >
        {isOpenCouponArea ? "クーポンを閉じる" : "クーポンを利用する"}
      </button>
      {isOpenCouponArea && (
        <div className="mt-3">
          {appliedCoupon && appliedCoupon.amount > 0 ? (
            <>
              <div className="mt-3 p-2 bg-blue-100 text-blue-600 text-m rounded-md">
                クーポン「{appliedCoupon.code}」が適用され、{appliedCoupon.amount.toLocaleString()}円が割引されました！
                <button
                  onClick={handleRemoveCoupon}
                  className="mt-2 text-sm text-red-500 hover:text-red-700 flex items-center underline"
                >
                  クーポンの適用を取り消す
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="text-sm text-gray-700">クーポンコードをお持ちの方は入力してください</p>
              <input
                type="text"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                placeholder="コードを入力"
                className="w-full p-2 mt-2 border border-blue-500 bg-blue-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
              {localError && <p className="text-sm text-red-500 mt-2">{localError}</p>}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleApplyCoupon();
                }}
                className="w-full mt-3 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition"
              >
                適用
              </button>
            </>
          )}
          <div className="mt-3 p-2 text-sm rounded-md">
            ※ 一度適用されたクーポンは支援キャンセルを行われて認められた場合であっても当該クーポン割引分は返金いたしかねます
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponArea;
